export default {

	auth: 'required',

	async action_home () {
		switch (Anvil.session.user.home_page) {

			case 'terminals':
				await Anvil.route('/c_order/terminal/list')
				break

			default:
			case 'dashboard':
				await Anvil.route('/home')
				break
		}
	},

	async page_home () {

		// A mai dátum
		const stat_date = Anvil.moment().format('YYYY-MM-DD')

		const [ companies, company_dbs, sites, terminals, aees, versions, /*stat_log,*/ issues, issue_tags ] = await Promise.all([
			Anvil.models.CompanyList.fetch(),
			Anvil.models.c_order.CompanyDBList.fetch(),
			Anvil.models.c_order.SiteList.fetch(),
			Anvil.models.c_order.TerminalList.fetch(),
			Anvil.models.c_order.AEEList.fetch(),
			Anvil.models.c_order.Versions.fetch(),
			//Anvil.REST.request('GET', `/stats/fetch_logs/${stat_date}`),
			Anvil.models.IssueList.fetchForUser(Anvil.session.user.id),
			Anvil.models.IssueTagList.fetch()
		])

		// Pénztárgépek
		const operated_aees = aees.data.filter(aee => (aee.operator_service_id === 145) && (aee.suspended == 0))
		const aee_inspection = {
			overdue: operated_aees.filter(aee => Anvil.moment(aee.last_inspection_d).add(1, 'year').isBefore()).length,
			due_1_week: operated_aees.filter(aee => Anvil.moment(aee.last_inspection_d).add(1, 'year').isBefore(Anvil.moment().add(7, 'day'))).length,
			due_1_month: operated_aees.filter(aee => Anvil.moment(aee.last_inspection_d).add(1, 'year').isBefore(Anvil.moment().add(1, 'month'))).length,
			due_3_months: operated_aees.filter(aee => Anvil.moment(aee.last_inspection_d).add(1, 'year').isBefore(Anvil.moment().add(3, 'month'))).length
		}

		// Terminálok
		terminals.data = terminals.data.filter(t => t.sandbox === 0 && t.archive === 0)
		const terminal_stats = {
			total: terminals.data.length,
			active_1_week: terminals.data.filter(t => Anvil.moment(t.last_report_dt).add(1, 'week').isAfter()).length,
			active_5_mins: terminals.data.filter(t => Anvil.moment(t.last_report_dt).add(5, 'minutes').isAfter()).length,
		}

		const version_channel_stats = {
			alpha: 0,
			beta: 0,
			stable: 0,
			disabled: 0
		}
		for (const t of terminals.data) {
			switch (t.update_channel) {
				case 'alpha':
					version_channel_stats.alpha++;
					break;
				case 'beta':
					version_channel_stats.beta++;
					break;
				case 'stable':
					version_channel_stats.stable++;
					break;
				case 'disabled':
					version_channel_stats.disabled++;
					break;
			}
		}

		const ntak_stats = {
			no_cert_unkn: terminals.data.filter(t => t.type == 'windows' && !t.settings && t.ntak_cert === null).length,
			no_cert_off: terminals.data.filter(t => t.type == 'windows' && (t.settings && t.settings.ntak_enabled == 'off') && t.ntak_cert === null).length,
			no_cert_prepare: terminals.data.filter(t => t.type == 'windows' && t.settings && t.settings.ntak_enabled == 'prepare' && t.ntak_cert === null).length,
			no_cert_on: terminals.data.filter(t => t.type == 'windows' && t.settings && t.settings.ntak_enabled == 'on' && t.ntak_cert === null).length,
			bad_cert_unkn: terminals.data.filter(t => t.type == 'windows' && !t.settings && t.ntak_cert && (Anvil.moment(t.ntak_cert.validto_time).isBefore() || t.ntak_cert.sandbox == '1')).length,
			bad_cert_off: terminals.data.filter(t => t.type == 'windows' && (t.settings && t.settings.ntak_enabled == 'off') && t.ntak_cert && (Anvil.moment(t.ntak_cert.validto_time).isBefore() || t.ntak_cert.sandbox == '1')).length,
			bad_cert_prepare: terminals.data.filter(t => t.type == 'windows' && t.settings && t.settings.ntak_enabled == 'prepare' && t.ntak_cert && (Anvil.moment(t.ntak_cert.validto_time).isBefore() || t.ntak_cert.sandbox == '1')).length,
			bad_cert_on: terminals.data.filter(t => t.type == 'windows' && t.settings && t.settings.ntak_enabled == 'on' && t.ntak_cert && (Anvil.moment(t.ntak_cert.validto_time).isBefore() || t.ntak_cert.sandbox == '1')).length,
			good_cert_unkn: terminals.data.filter(t => t.type == 'windows' && !t.settings && t.ntak_cert && !(Anvil.moment(t.ntak_cert.validto_time).isBefore() || t.ntak_cert.sandbox == '1')).length,
			good_cert_off: terminals.data.filter(t => t.type == 'windows' && (t.settings && t.settings.ntak_enabled == 'off') && t.ntak_cert && !(Anvil.moment(t.ntak_cert.validto_time).isBefore() || t.ntak_cert.sandbox == '1')).length,
			good_cert_prepare: terminals.data.filter(t => t.type == 'windows' && t.settings && t.settings.ntak_enabled == 'prepare' && t.ntak_cert && !(Anvil.moment(t.ntak_cert.validto_time).isBefore() || t.ntak_cert.sandbox == '1')).length,
			good_cert_on: terminals.data.filter(t => t.type == 'windows' && t.settings && t.settings.ntak_enabled == 'on' && t.ntak_cert && !(Anvil.moment(t.ntak_cert.validto_time).isBefore() || t.ntak_cert.sandbox == '1')).length
		}

		// c-Order verziók
		const version_stats = Object.entries(terminals.data.reduce((acc, t) => {
			if (!acc[t.version]) acc[t.version] = {
				count: 0,
				state: versions.verstate(t.version)
			}
			acc[t.version].count++
			return acc
		}, {})).sort((a, b) => Anvil.versions.compare((Anvil.versions.validate(a[0]) ? a[0] : '0'), (Anvil.versions.validate(b[0]) ? b[0] : '0'), '<') ? 1 : -1)

		Anvil.renderPage('/main/page_home', { companies, company_dbs, sites, terminals, aees, issues, issue_tags, operated_aees, aee_inspection, terminal_stats, ntak_stats, version_stats, version_channel_stats, versions, stat_date /*, stat_log */})
	},

	async action_refresh () {

		const [ companies, company_dbs, sites, terminals, aees, versions, /*stat_log,*/ issues, issue_tags ] = await Promise.all([
			Anvil.models.CompanyList.fetch(),
			Anvil.models.c_order.CompanyDBList.fetch(),
			Anvil.models.c_order.SiteList.fetch(),
			Anvil.models.c_order.TerminalList.fetch(),
			Anvil.models.c_order.AEEList.fetch(),
			Anvil.models.c_order.Versions.fetch(),
			//Anvil.REST.request('GET', `/stats/fetch_logs/${stat_date}`),
			Anvil.models.IssueList.fetchForUser(Anvil.session.user.id),
			Anvil.models.IssueTagList.fetch()
		])

		Anvil.page.issues = issues
		Anvil.page.issue_tags = issue_tags
		Anvil.page.companies = companies
		Anvil.page.company_dbs = company_dbs
		Anvil.page.sites = sites
		Anvil.page.terminals = terminals
		Anvil.page.aees = aees
		Anvil.models.components.Grid.find('#issue_grid').list = issues
	},

	async action_display_traffic (date) {

		const stat_date = date || Anvil.moment().format('YYYY-MM-DD')
		const stat_log = await Anvil.REST.request('GET', `/stats/fetch_logs/${stat_date}`)

		Anvil.page.stat_date = stat_date
		Anvil.page.stat_log = stat_log

		Anvil.render('/main/panel_server_traffic', { stat_date, stat_log }, '#panel-server-traffic')
	}
}
